/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class ApplyTemplate extends Sv {
    constructor() {
        super();
        this.baseUrl += '/applyTemplate';
    }

    data({ applyTemplateName, isAvailable, schoolOrgId, currentPage, pageSize } = {}) {
        return super.get('/data', {
            applyTemplateName,
            isAvailable,
            schoolOrgId,
            currentPage,
            pageSize,
        });
    }

    findApplyTemplateDetailList({ certExamId } = {}) {
        return super.get('/findApplyTemplateDetailList', {
            certExamId,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, applyTemplateName, materialsListJson, isAvailable, applyTemplateDesc, schoolOrgId } = {}) {
        return super.post('/save', {
            id,
            applyTemplateName,
            materialsListJson,
            isAvailable,
            applyTemplateDesc,
            schoolOrgId,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    validatorApplyTemplateName({ id, applyTemplateName } = {}) {
        return super.get('/validatorApplyTemplateName', {
            id,
            applyTemplateName,
        });
    }
}

export default new ApplyTemplate();
export { ApplyTemplate };
